import capitalizeFirstLetter from "./capitilizeFirstLetter";

export default (path) => {
  const title = path.split("/")[1].split("-").join(" ");
  return capitalizeFirstLetter(title);
};
